export default __webpack_public_path__ + "static/media/account-card-slim-vectors.9e031891.png";